module.exports = __webpack_public_path__ + "cd7980bbb2f60528102b8822ce7208ed.svg";